export const SPLIT_VARIABLE_PANEL_KEY_DELIMITER = ':split-name-';

export const SPLIT_VARIABLE_VALUE_DELIMITER = ':split-value-';
